import { ApiRoute } from "PFCore/utilities/routes";
import { Id } from "PFTypes/id";
import { SamlConfig } from "PFTypes/saml_config";

export type NewSamlConfig = Omit<SamlConfig, "id">;

export const getSamlConfig = (id: Id): Promise<SamlConfig> =>
  // @ts-ignore
  $.ajax({
    url: ApiRoute(`/api/admin/saml_configs/${id}`),
    api_version: 1 // eslint-disable-line camelcase
  });

export const createSamlConfig = (data: NewSamlConfig): Promise<SamlConfig> =>
  // @ts-ignore
  $.ajax({
    url: ApiRoute("/api/admin/saml_configs"),
    api_version: 1, // eslint-disable-line camelcase
    method: "POST",
    data
  });

export const updateSamlConfig = (id: Id, data: SamlConfig): Promise<SamlConfig> =>
  // @ts-ignore
  $.ajax({
    url: ApiRoute(`/api/admin/saml_configs/${id}`),
    api_version: 1, // eslint-disable-line camelcase
    method: "PUT",
    data
  });

export const deleteSamlConfig = (id: Id): Promise<{ message: string }> =>
  // @ts-ignore
  $.ajax({
    url: ApiRoute(`/api/admin/saml_configs/${id}`),
    method: "DELETE",
    api_version: 1 // eslint-disable-line camelcase
  });

export const parseSamlConfigMetadata = (data: FormData): Promise<SamlConfig> =>
  // @ts-ignore
  $.ajax({
    method: "POST",
    url: ApiRoute("/api/admin/saml_configs/metadata"),
    api_version: 1, // eslint-disable-line camelcase
    data,
    contentType: false,
    processData: false
  });

export const activateSamlConfig = (id: Id): Promise<SamlConfig> =>
  // @ts-ignore
  $.ajax({
    url: ApiRoute(`/api/admin/saml_configs/${id}/activate`), // TODO where is deactivate
    method: "POST",
    api_version: 1 // eslint-disable-line camelcase
  });

export const getSamlToken = (): Promise<{ saml_token: string }> =>
  // @ts-ignore
  $.ajax({
    url: ApiRoute("/api/admin/saml_configs/saml_token"),
    api_version: 1 // eslint-disable-line camelcase
  });
